import type { PrimeVueConfiguration } from 'primevue'

import { englishLocale } from '@/libs/primevue/locales/primevueEn.ts'
import { slovenianLocale } from '@/libs/primevue/locales/primevueSl.ts'

export const changePrimevueLanguage = (primevue: { config: PrimeVueConfiguration }, language: string) => {
    if (!language || language === 'sl') primevue.config.locale = slovenianLocale
    else if (language === 'en') primevue.config.locale = englishLocale
}
